class CollectionNavMenu extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if(this.dataset.lazyload === "true") {
      this._fetchMenu();
    }
  }

  async _fetchMenu() {
    const result = await fetch(window.location.pathname + `?sections=ajax-collection-side-menu&nav-item-handle=${this.dataset.navItemHandle}`);
    const json = await result.json();
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = json[Object.keys(json)[0]];
    let menu;
    if(this.dataset.type === "desktop") {
      menu = tempDiv.querySelector('#desktop-menu');
    } else {
      menu = tempDiv.querySelector('#mobile-menu');
    }
    if(menu) {
      this.innerHTML = menu.innerHTML;
    } else {
      this.innerHTML = "";
    }
  }
}

customElements.define('collection-nav-menu', CollectionNavMenu);